import { StyleProp } from 'react-native';
import { TextStyle } from '@expo/html-elements/build/primitives/Text';
import { useMemo } from 'react';
import { DEFAULT_LATO_FONT_STYLE_KEY, FontFamily } from 'src/constants/font.constants';
import { getLatoFontFamilyByStyle } from '../text-lato/TextLato.logic';
import { getWorkSansFontFamilyByStyle } from '../text-work-sans/TextWorkSans.logic';
import { useFontsContext } from 'src/contexts/FontsContext';
import { getCustomFontFamily } from 'src/helpers/font.helper';

export function useDynamicFont(fontFamily: string, fontStyle: string, style: StyleProp<TextStyle>) {
  const { loadingCustomFonts } = useFontsContext();

  const dynamicFontStyle = useMemo(() => {
    if (!fontFamily) {
      return undefined;
    } else if (fontFamily === FontFamily.Lato && style) {
      // If Lato is selected, use the Lato font family logic
      return {
        fontFamily: getLatoFontFamilyByStyle(style),
      };
    } else if (fontFamily === FontFamily.WorkSans && style) {
      // If WorkSans is selected, use the WorkSans font family logic
      return {
        fontFamily: getWorkSansFontFamilyByStyle(style),
      };
    } else if (fontFamily && fontStyle) {
      loadingCustomFonts();
      // For custom fonts, get the appropriate font family
      return {
        fontFamily: getCustomFontFamily(fontFamily, fontStyle),
      };
    }
    return {
      fontFamily: DEFAULT_LATO_FONT_STYLE_KEY,
    };
  }, [fontFamily, fontStyle, style]);

  return dynamicFontStyle;
}
